import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters89mmTiltControlFaceFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters89"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={350.69}
          y1={491.28}
          x2={350.69}
          y2={486.07}
          gradientTransform="translate(.5 -431.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={461.76}
          y1={491.28}
          x2={461.76}
          y2={486.07}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={350.69}
          y1={524.32}
          x2={350.69}
          y2={519.12}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={461.76}
          y1={524.32}
          x2={461.76}
          y2={519.12}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={350.69}
          y1={557.27}
          x2={350.69}
          y2={552.06}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={461.76}
          y1={557.27}
          x2={461.76}
          y2={552.06}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={350.69}
          y1={590.11}
          x2={350.69}
          y2={584.91}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={461.76}
          y1={590.11}
          x2={461.76}
          y2={584.91}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={461.76}
          y1={623.06}
          x2={461.76}
          y2={617.85}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={350.69}
          y1={623.06}
          x2={350.69}
          y2={617.85}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={350.69}
          y1={656}
          x2={350.69}
          y2={650.8}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={461.76}
          y1={656}
          x2={461.76}
          y2={650.8}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          x1={350.69}
          y1={688.95}
          x2={350.69}
          y2={683.74}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={461.76}
          y1={688.95}
          x2={461.76}
          y2={683.74}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          x1={350.69}
          y1={721.89}
          x2={350.69}
          y2={716.69}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={461.76}
          y1={721.89}
          x2={461.76}
          y2={716.69}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          x1={350.69}
          y1={754.84}
          x2={350.69}
          y2={749.63}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={461.76}
          y1={754.84}
          x2={461.76}
          y2={749.63}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          x1={350.69}
          y1={787.78}
          x2={350.69}
          y2={782.58}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={461.76}
          y1={787.78}
          x2={461.76}
          y2={782.58}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          x1={41.9}
          y1={505.23}
          x2={41.9}
          y2={472.69}
          gradientTransform="translate(.5 -431.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={7082.3}
          y1={505.23}
          x2={7082.3}
          y2={472.69}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          x1={41.9}
          y1={538.29}
          x2={41.9}
          y2={505.74}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={7082.3}
          y1={538.29}
          x2={7082.3}
          y2={505.74}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          x1={41.9}
          y1={571.24}
          x2={41.9}
          y2={538.7}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={7082.3}
          y1={571.24}
          x2={7082.3}
          y2={538.7}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          x1={41.9}
          y1={604.06}
          x2={41.9}
          y2={571.53}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={7082.3}
          y1={604.06}
          x2={7082.3}
          y2={571.53}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          x1={41.9}
          y1={637.03}
          x2={41.9}
          y2={604.48}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={7082.3}
          y1={637.03}
          x2={7082.3}
          y2={604.48}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-31"
          x1={41.9}
          y1={669.98}
          x2={41.9}
          y2={637.44}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-32"
          x1={7082.3}
          y1={669.98}
          x2={7082.3}
          y2={637.44}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-33"
          x1={41.9}
          y1={702.89}
          x2={41.9}
          y2={670.36}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-34"
          x1={7082.3}
          y1={702.89}
          x2={7082.3}
          y2={670.36}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-35"
          x1={41.9}
          y1={735.86}
          x2={41.9}
          y2={703.31}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-36"
          x1={7082.3}
          y1={735.86}
          x2={7082.3}
          y2={703.31}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-37"
          x1={41.9}
          y1={768.81}
          x2={41.9}
          y2={736.28}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-38"
          x1={7082.3}
          y1={768.81}
          x2={7082.3}
          y2={736.28}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-39"
          x1={41.9}
          y1={801.73}
          x2={41.9}
          y2={769.19}
          xlinkHref="#prefix__linear-gradient-21"
        />
        <linearGradient
          id="prefix__linear-gradient-40"
          x1={7082.3}
          y1={801.73}
          x2={7082.3}
          y2={769.19}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient-21"
        />
        <pattern
          id="prefix__SVGID_1_"
          data-name="SVGID 1"
          width={135}
          height={135}
          patternTransform="matrix(.95 0 0 .94 457.49 426.37)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image"
            className="prefix__cls-2"
            xlinkHref="#prefix__image-2"
          />
        </pattern>
        <pattern
          id="prefix__SVGID_1_3"
          data-name="SVGID 1 3"
          width={135}
          height={135}
          patternTransform="matrix(.95 0 0 .94 472.84 407.82)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image-3"
            data-name="image"
            className="prefix__cls-2"
            xlinkHref="#prefix__image-2"
          />
        </pattern>
        <pattern
          id="prefix__SVGID_1_5"
          data-name="SVGID 1 5"
          width={135}
          height={135}
          patternTransform="matrix(.96 0 0 .94 416.15 426.37)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image-4"
            data-name="image"
            className="prefix__cls-2"
            xlinkHref="#prefix__image-2"
          />
        </pattern>
        <pattern
          id="prefix__SVGID_1_7"
          data-name="SVGID 1 7"
          width={135}
          height={135}
          patternTransform="matrix(.95 0 0 .94 581.31 426.55)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image-5"
            data-name="image"
            className="prefix__cls-2"
            xlinkHref="#prefix__image-2"
          />
        </pattern>
        <style>
          {
            '.prefix__cls-1,.prefix__cls-46,.prefix__cls-6{fill:none}.prefix__cls-2,.prefix__cls-46,.prefix__cls-6{isolation:isolate}.prefix__cls-4,.prefix__cls-6{opacity:.2}.prefix__cls-5{fill:#4d4d4d}.prefix__cls-46,.prefix__cls-6{stroke:#4d4d4d}.prefix__cls-46,.prefix__cls-53,.prefix__cls-54,.prefix__cls-6{stroke-miterlimit:10;stroke-width:.95px}.prefix__cls-7{fill:#333}.prefix__cls-46{opacity:.15}.prefix__cls-53,.prefix__cls-54{fill:#efefef;stroke:gray}.prefix__cls-53{opacity:.2}.prefix__cls-54{opacity:.1}'
          }
        </style>
        <image
          id="prefix__image-2"
          width={135}
          height={135}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAACHCAYAAAA850oKAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVR4Xu3SMRGAMADAwFL/xmqAHSXUQHMI4H/OmOu51zvgYH4F/Jc5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SOYgmYNkDpI5SBszfASNAbiFZQAAAABJRU5ErkJggg=="
        />
      </defs>
      <path
        d="M515 13.72H13.63v383.51H542.5V13.72zm-217 46h106.4v27.89H298zm0 33.1h106.4v27.75H298zm0 32.91h106.4v27.66H298zm0 32.82h106.4v27.76H298zm0 33h106.4v27.75H298zm0 32.91h106.4v27.76H298zm0 32.91h106.4v27.76H298zm0 33h106.4v27.76H298zm0 32.91h106.4v27.82H298zm0 32.92h106.4v14H298zm217 14H409.44v-14h105.63v14zm0-19.13H409.44v-27.73h105.63v27.76zm0-33H409.44v-27.73h105.63v27.75zm0-32.91H409.44v-27.74h105.63v27.76zm0-32.91H409.44V224.5h105.63v27.76zm0-33H409.44V191.5h105.63v27.76zm0-32.91H409.44v-27.75h105.63v27.76zm0-32.92H409.44v-27.65h105.63v27.66zm0-32.91H409.44V92.86h105.63v27.64zm0-32.91H409.44V59.76h105.63v27.85zm0-33H409.44V40.72h-5V54.6H298V40.72h217z"
        fill="url(#shutters89)"
      />
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M41.59 397.7H13.15V13.25h28.44zm-27.49-.94h26.53V14.19H14.1z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M258.58 41.19H40.63V13.25h218zm-217-.94h216V14.19h-216z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M258.58 397.7H40.63v-27.94h218zm-217-.94h216V370.7h-216z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M515.5 41.19h-218V13.25h218zm-217-.94h216V14.19h-216z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M515.5 397.7h-218v-27.94h218zm-217-.94h216V370.7h-216z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M542.94 397.7H514.5V13.25h28.44zm-27.44-.94H542V14.19h-26.5z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M278.42 397.7h-20.8V13.25h20.8zm-19.92-.84h19.18V14.09H258.5z"
        />
        <path
          className="prefix__cls-5"
          d="M298.37 397.7h-20.8V13.25h20.8zm-19.95-.84h19.18V14.09h-19.18z"
        />
      </g>
      <path className="prefix__cls-6" d="M147.5 40.72h4.96v329.5h-4.96z" />
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-7"
          d="M13.63 73.17h2.48v35.73h-2.48zM13.63 302.06h2.48v35.73h-2.48z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-7"
          d="M539.98 73.17h2.48v35.73h-2.48zM539.98 302.06h2.48v35.73h-2.48z"
        />
      </g>
      <path
        fill="url(#prefix__linear-gradient)"
        d="M297.99 54.6h106.4v5.16h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-2)"
        d="M409.44 54.6h105.63v5.16H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-3)"
        d="M297.99 87.61h106.4v5.25h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-4)"
        d="M409.44 87.61h105.63v5.25H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-5)"
        d="M297.99 120.52h106.4v5.16h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-6)"
        d="M409.44 120.52h105.63v5.16H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-7)"
        d="M297.99 153.43h106.4v5.25h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-8)"
        d="M409.44 153.43h105.63v5.25H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-9)"
        d="M409.44 186.35h105.63v5.16H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-10)"
        d="M297.99 186.35h106.4v5.16h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-11)"
        d="M297.99 219.26h106.4v5.25h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-12)"
        d="M409.44 219.26h105.63v5.25H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-13)"
        d="M297.99 252.27h106.4v5.16h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-14)"
        d="M409.44 252.27h105.63v5.16H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-15)"
        d="M297.99 285.18h106.4v5.25h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-16)"
        d="M409.44 285.18h105.63v5.25H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-17)"
        d="M297.99 318.09h106.4v5.25h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-18)"
        d="M409.44 318.09h105.63v5.25H409.44z"
      />
      <path
        fill="url(#prefix__linear-gradient-19)"
        d="M297.99 351.1h106.4v5.16h-106.4z"
      />
      <path
        fill="url(#prefix__linear-gradient-20)"
        d="M409.44 351.1h105.63v5.16H409.44z"
      />
      <path className="prefix__cls-6" d="M404.38 40.72h4.96v329.5h-4.96z" />
      <path
        fill="url(#prefix__linear-gradient-21)"
        d="M43.21 41.19h-1.62v32.54l1.62-32.54z"
      />
      <path
        fill="url(#prefix__linear-gradient-22)"
        d="M256.48 41.19h1.62v32.54l-1.62-32.54z"
      />
      <path
        fill="url(#prefix__linear-gradient-23)"
        d="M43.21 74.2h-1.62v32.63l1.62-32.63z"
      />
      <path
        fill="url(#prefix__linear-gradient-24)"
        d="M256.48 74.2h1.62v32.63l-1.62-32.63z"
      />
      <path
        fill="url(#prefix__linear-gradient-25)"
        d="M43.21 107.2h-1.62v32.54l1.62-32.54z"
      />
      <path
        fill="url(#prefix__linear-gradient-26)"
        d="M256.48 107.2h1.62v32.54l-1.62-32.54z"
      />
      <path
        fill="url(#prefix__linear-gradient-27)"
        d="M43.21 140.03h-1.62v32.53l1.62-32.53z"
      />
      <path
        fill="url(#prefix__linear-gradient-28)"
        d="M256.48 140.03h1.62v32.53l-1.62-32.53z"
      />
      <path
        fill="url(#prefix__linear-gradient-29)"
        d="M43.21 172.94h-1.62v32.63l1.62-32.63z"
      />
      <path
        fill="url(#prefix__linear-gradient-30)"
        d="M256.48 172.94h1.62v32.63l-1.62-32.63z"
      />
      <path
        fill="url(#prefix__linear-gradient-31)"
        d="M43.21 205.94h-1.62v32.54l1.62-32.54z"
      />
      <path
        fill="url(#prefix__linear-gradient-32)"
        d="M256.48 205.94h1.62v32.54l-1.62-32.54z"
      />
      <path
        fill="url(#prefix__linear-gradient-33)"
        d="M43.21 238.86h-1.62v32.53l1.62-32.53z"
      />
      <path
        fill="url(#prefix__linear-gradient-34)"
        d="M256.48 238.86h1.62v32.53l-1.62-32.53z"
      />
      <path
        fill="url(#prefix__linear-gradient-35)"
        d="M43.21 271.77h-1.62v32.63l1.62-32.63z"
      />
      <path
        fill="url(#prefix__linear-gradient-36)"
        d="M256.48 271.77h1.62v32.63l-1.62-32.63z"
      />
      <path
        fill="url(#prefix__linear-gradient-37)"
        d="M43.21 304.78h-1.62v32.53l1.62-32.53z"
      />
      <path
        fill="url(#prefix__linear-gradient-38)"
        d="M256.48 304.78h1.62v32.53l-1.62-32.53z"
      />
      <path
        className="prefix__cls-46"
        d="M41.11 172.47h106.4v32.91H41.11zM152.47 172.47H258.1v32.91H152.47z"
      />
      <path
        fill="url(#prefix__linear-gradient-39)"
        d="M43.21 337.69h-1.62v32.54l1.62-32.54z"
      />
      <path
        fill="url(#prefix__linear-gradient-40)"
        d="M256.48 337.69h1.62v32.54l-1.62-32.54z"
      />
      <path
        className="prefix__cls-46"
        d="M147.6 40.72H41.11v32.92H147.5V37.81h4.97v35.83H258.1V40.72H152.2M41.11 73.73h106.4v32.91H41.11zM152.47 73.73H258.1v32.91H152.47zM152.47 106.74H258.1v32.91H152.47zM41.11 106.74h106.4v32.91H41.11z"
      />
      <path
        className="prefix__cls-46"
        d="M41.11 139.56h106.4v32.91H41.11zM152.47 139.56H258.1v32.91H152.47zM41.11 205.38h106.4v32.91H41.11zM152.47 205.38H258.1v32.91H152.47zM41.11 238.39h106.4v32.91H41.11zM152.47 238.39H258.1v32.91H152.47zM41.11 271.3h106.4v32.91H41.11zM152.47 271.3H258.1v32.91H152.47zM41.11 304.31h106.4v32.91H41.11zM152.47 304.31H258.1v32.91H152.47zM41.11 337.22h106.4v32.91H41.11zM152.47 337.22H258.1v32.91H152.47z"
      />
      <path
        style={{
          isolation: 'isolate',
        }}
        strokeMiterlimit={10}
        stroke="#4d4d4d"
        opacity={0.2}
        fill="none"
        d="M.5.5h555.2v410H.5z"
      />
      <path
        d="M.5.5v410h555.2V.5zm542 396.75H13.75V13.75H542.5z"
        fill="url(#shutters89)"
      />
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M554.7 1.5v408H1.5V1.5h553.2M12.75 398.25H543.5V12.75H12.75v385.5M555.7.5H.5v410h555.2zM13.75 397.25V13.75H542.5v383.5z"
        />
      </g>
      <path
        className="prefix__cls-46"
        d="M150 32.15a4.29 4.29 0 014.29 4.29v4.29h-8.57v-4.29a4.29 4.29 0 014.28-4.29z"
      />
      <path fill="url(#prefix__SVGID_1_5)" d="M147.96 39.8h4.03v1.78h-4.03z" />
      <path
        className="prefix__cls-46"
        d="M406.85 32.15a4.29 4.29 0 014.29 4.29v4.29h-8.57v-4.29a4.29 4.29 0 014.29-4.29z"
      />
      <path fill="url(#prefix__SVGID_1_7)" d="M404.86 39.62h4.01v1.78h-4.01z" />
      <path className="prefix__cls-46" d="M409.46 40.51v-3.06h-5.08v3.06" />
      <path
        className="prefix__cls-53"
        d="M542.48 13.74l12.25-12.25M13.73 397.26L1.48 409.51M542.48 397.26l12.25 12.25"
      />
      <path
        className="prefix__cls-54"
        d="M3.87 3.88h547.96M11.46 10.69h533.86M3.87 407.07h547.96M11.46 400.26h533.86M3.71 4.37v403.28M10.52 10.69v389.78M552.56 4.37v403.28M545.75 10.69v389.78"
      />
      <path className="prefix__cls-53" d="M13.21 13.11L1.5 1.5" />
    </svg>
  );
};
